import type { ListItemProps } from '@mui/material';
import { ListItem } from '@mui/material';

import { tss } from 'tss-react/mui';
import { forwardRef } from 'react';

export const useStyles = tss
  .withParams<{ hoverHighlight: boolean; button: boolean }>()
  .create(({ theme, hoverHighlight, button }) => {
    return {
      item: {
        ...(hoverHighlight && {
          transition: 'background-color 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: theme.darkCard,
          },
        }),
        ...(button && { cursor: 'pointer' }),
      },
      rounded: {
        borderRadius: '20px',
      },
    };
  });

interface Or2ListItemProps extends ListItemProps {
  hoverHighlight?: boolean;
  rounded?: boolean;
  button?: boolean;
}

export const Or2ListItem = forwardRef<HTMLLIElement, Or2ListItemProps>(
  (
    {
      children,
      className,
      rounded,
      hoverHighlight = true,
      button = false,
      ...other
    },
    ref,
  ) => {
    const { classes, cx } = useStyles({ hoverHighlight, button });

    return (
      <ListItem
        ref={ref}
        className={cx(
          classes.item,
          {
            [classes.rounded]: rounded,
          },
          className,
        )}
        {...other}
      >
        {children}
      </ListItem>
    );
  },
);

Or2ListItem.displayName = 'Or2ListItem';
